// extracted by mini-css-extract-plugin
export default {"container":"NavLinkWithIcon_container__fs9Gt","reverse":"NavLinkWithIcon_reverse__NwWVr"};